<template>
  <v-select 
    :disabled="fromTimeAnalysis && !items.length"
    :class="fromTimeAnalysis && !items.length ? 'meetingType-select-disabled' : fromTimeAnalysis ? 'meetingType-select' : ''"
    v-model="selectedItem"
    :items="items"
    :label="title"
    multiple
    chips
    small-chips
    item-text="name"
    item-value="name"
    solo
    prepend-inner-icon="mdi-filter"
    :menu-props="{ bottom: true, offsetY: true }"
    clearable
    hide-details
    dense
    :placeholder="$t('agenda.lblMeetingType')"
  >
    <template v-slot:prepend-item>
      <v-list-item
        class="list-item-node"
        ripple
        @mousedown.prevent
        @click="toggle"
      >
        <v-list-item-action>
          <v-icon color="primary">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> {{$t('selectAll') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <!-- <span v-if="index === 0" class="secondary--text text-caption">
        {{ value.length }} Filter Selected
      </span> -->
      <v-chip small v-if="index === 0" :class="fromTimeAnalysis ? 'meetingType-chip' : ''">
        <span>{{ item.name }}</span>
      </v-chip>
      <span v-if="index === 1" :class="fromTimeAnalysis ? 'meetingType-text text-caption' : 'grey--text text-caption'">
        (+{{ value.length - 1 }} others)
      </span>
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "FilterList",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    listHeight: {
      type: Number,
      default: 250,
    },
    title: {
      type: String,
      default: "Meeting types",
    },
    fromTimeAnalysis: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
    selectAllFilters() {
      return this.selectedItem.length === this.items.length;
    },
    selectSomeFilters() {
      return this.selectedItem.length > 0 && !this.selectAllFilters;
    },
    icon() {
      if (this.selectAllFilters) return "mdi-checkbox-marked";
      if (this.selectSomeFilters) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllFilters) {
          this.selectedItem = [];
        } else {
          this.selectedItem = this.items.map((item) => item.name);
        }
      });
    },
  },
};
</script>

<style scoped>
.list-item-node {
  height: 32px;
  min-height: 32px !important;
}

.items-list {
  /* height: 250px;  */
  overflow-y: auto;
}

::v-deep .v-list-item {
  height: 38px;
  min-height: 38px !important;
}
.theme--light.v-text-field--solo.meetingType-select /deep/ .v-input__slot {
  background: #004c7a !important;
}
.theme--light.v-text-field--solo.meetingType-select-disabled /deep/ .v-input__slot {
  background: #dddddd !important;
  box-shadow: none;
}
.meetingType-text, .theme--light.v-text-field--solo.meetingType-select /deep/ .v-icon, .theme--light.v-text-field--solo.meetingType-select /deep/ input::placeholder {
  color: #fff !important;
}
.theme--light.v-text-field--solo.meetingType-select /deep/ .v-label {
  color: #fff !important;
  line-height: 18px; 
}
.theme--light.v-text-field--solo.meetingType-select-disabled /deep/ .v-select__selections, .theme--light.v-text-field--solo.meetingType-select /deep/ .v-select__selections {
  min-height: 40px;
}
.meetingType-chip {
  background: #fff !important;
}
</style>